import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../../components/ContactModal";
function Block7() {

    return (
            <section className="layout-pt-20 layout-pb-20">
                <div className="auto-container">
                    <div className="sec-title-outer">
                        <div className="sec-title" style={{width: "100%", textAlign: "center"}}>
                            <h2 className="homepage">Des webinaires<span> concrets, utiles et adaptés à vos enjeux</span></h2>
                            <div className="text homepage">
                                Nous proposons des webinaires aux thématiques construites à partir de vos <b>enjeux concrets</b>,
                                pour <b>lever les idées reçues</b> et <b>faire évoluer les pratiques</b>. L’objectif est de donner à
                                vos équipes <b>des clés de compréhension</b> et <b>d’action sur le handicap au travail</b>.
                                Découvrez quelques <b>exemples de thématiques</b> que nous pouvons aborder.
                            </div>
                        </div>
                    </div>

                    <div className="row wow fadeInUp">

                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="feature-block">
                                <div className="inner-box">
                                    <figure className="image homepage">
                                        <img src="/images/resource/mieux-comprendre.jpg" alt="mieux-comprendre"
                                             className="homepage"/>
                                    </figure>
                                    <div className="overlay-box">
                                        <div className="content">
                                            <h5>Mieux comprendre le handicap au travail pour en faire une force</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="feature-block">
                                <div className="inner-box">
                                    <figure className="image">
                                        <img src="/images/resource/dejouer-biais.jpg" alt="dejouer-biais"
                                             className="homepage"/>
                                    </figure>
                                    <div className="overlay-box">
                                        <div className="content">
                                            <h5>Déjouer les biais et préjugés sur le handicap</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="feature-block">
                                <div className="inner-box">
                                    <figure className="image">
                                        <img src="/images/resource/reconnaissance-atout.jpg" alt="reconnaissance-atout"
                                             className="homepage"/>
                                    </figure>
                                    <div className="overlay-box">
                                        <div className="content">
                                            <h5>La reconnaissance handicap : en faire un atout</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="feature-block">
                                <div className="inner-box">
                                    <figure className="image">
                                        <img src="/images/resource/handicap-invisible.jpg" alt="handicap-invisible"
                                             className="homepage"/>
                                    </figure>
                                    <div className="overlay-box">
                                        <div className="content">
                                            <h5>Handicap invisible : le comprendre pour mieux l’accompagner</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="sec-title-outer">
                        <div className="sec-title">
                            <div className="text homepage">
                                <b>Autres thématiques possibles :</b> Témoignages de collaborateurs en situation de handicap,
                                Travailler avec un·e collègue en situation de handicap, Handicap, santé et prévention,
                                Réussir sa carrière avec un handicap, Handicap et cohésion sociale, Handicap et résilience,
                                Handicap et bien-être au travail, Handicap et RSE, Neurodiversité, Handicap psychique,
                                Santé mentale, Recrutement inclusif, Management inclusif / témoignages de managers,
                                Compensation du handicap / adaptation du poste ...
                            </div>
                            <div className="text-center">
                                <ContactModal textButton="Échangeons sur vos besoins" showText={false} small="small" linkPageContact={false} iframe={false} couleur={false} formModal={true}/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    )
}

export default Block7;
